import React, { Component } from 'react';  
import { 
	getBankType,
	bankType,
	smrzCardNumber,
	clearSmrzThird
} from '../../action/investmentAction.js';
import { connect } from 'react-redux';
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';

class CertificationCardAgain extends Component {
	state = {
		cardNumber: this.props.smrzCardNumber,
		enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
	}

	componentWillMount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
		document.getElementsByTagName('title')[0].innerHTML = "实名认证";
		console.log("控制人:", this.props.location.state.actualController, "受益人:", this.props.location.state.actualBeneficiary, "控制人证件类型:", this.props.location.state.actualControllerCertType, "受益人证件类型:", this.props.location.state.actualBeneficiaryCertType, "控制人证件号:", this.props.location.state.actualControllerCertNo, "受益人证件号:", this.props.location.state.actualBeneficiaryCertNo, "组织:", this.props.location.state.officialsOrRelatives)
	}

	goCertification = () => {
		let { savePicFun, name, certNo, address, careerCode, cityCode, provinceCode, actualBeneficiary, actualController, actualBeneficiaryCertType, actualBeneficiaryCertNo, actualControllerCertType, actualControllerCertNo, officialsOrRelatives, phoneNo, annualIncomeV2,annualIncome,actualControllerBirthday,actualControllerValidTerm,actualControllerValidEver,actualControllerSex,actualControllerMobileNo,actualControllerProvince,actualControllerProfession,actualControllerAddress,actualControllerPostcode,actualControllerEmail,actualBeneficiaryValidTerm,actualBeneficiaryValidEver,actualBeneficiarySex,actualBeneficiaryBirthday,actualBeneficiaryMobileNo,actualBeneficiaryProvince,actualBeneficiaryAddress,actualBeneficiaryPostcode,actualBeneficiaryProfession,actualBeneficiaryEmail,conversationId,actualBeneficiaryCity,actualControllerCity,certLifeTime,certValidEver,certValidTerm } = this.props.location.state;
		let { cardNumber } = this.state;
		let { dispatch } = this.props;
		dispatch(bankType(null));
        dispatch(getBankType({
        	bankCardNo: cardNumber
        }));
        let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    	let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
        hashHistory.push({
			pathname: "/certificationSetPhone",
			state: {
				phoneNo: phoneNo,
				name: name,
				certNo: certNo,
				certType: 0,
				bankAccountShowNo: cardNumber,
				address: address,
				careerCode: careerCode,
				cityCode: cityCode,
				provinceCode: provinceCode,
				actualBeneficiary: actualBeneficiary,
				actualController: actualController,
				actualBeneficiaryCertType: actualBeneficiaryCertType,
				actualBeneficiaryCertNo: actualBeneficiaryCertNo,
				actualControllerCertType: actualControllerCertType,
				actualControllerCertNo: actualControllerCertNo,
				officialsOrRelatives: officialsOrRelatives, 
				callback: callback,
				route: route,
				enterType:this.state.enterType,
				annualIncomeV2:annualIncomeV2,
				annualIncome:annualIncome,
				actualControllerBirthday: actualControllerBirthday,
				actualControllerValidTerm: actualControllerValidTerm,
				actualControllerValidEver: actualControllerValidEver,
				actualControllerSex: actualControllerSex,
				actualControllerMobileNo: actualControllerMobileNo,
				actualControllerProvince: actualControllerProvince,
				actualControllerProfession: actualControllerProfession,
				actualControllerAddress: actualControllerAddress,
				actualControllerPostcode: actualControllerPostcode,
				actualControllerEmail: actualControllerEmail,
				actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
				actualBeneficiaryValidEver: actualBeneficiaryValidEver,
				actualBeneficiarySex: actualBeneficiarySex,
				actualBeneficiaryBirthday: actualBeneficiaryBirthday,
				actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
				actualBeneficiaryProvince: actualBeneficiaryProvince,
				actualBeneficiaryAddress: actualBeneficiaryAddress,
				actualBeneficiaryPostcode: actualBeneficiaryPostcode,
				actualBeneficiaryProfession: actualBeneficiaryProfession,
				actualBeneficiaryEmail: actualBeneficiaryEmail,
				actualBeneficiaryCity: actualBeneficiaryCity,
				actualControllerCity: actualControllerCity,
				savePicFun: savePicFun,
				conversationId: conversationId,
				certLifeTime: certLifeTime,
				certValidEver: certValidEver,
				certValidTerm: certValidTerm,
			},
			query: {enterType:this.state.enterType
				,
				activityId:this.props.location.query.activityId}
		});
		dispatch(clearSmrzThird(phoneNo));
	}

	changeCardNumber = (event) => {
		let { dispatch } = this.props;
		this.setState({
			cardNumber :event.target.value
		})
		dispatch(smrzCardNumber(event.target.value));
	}

	goBack = () => {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
		hashHistory.goBack();
	}

	componentWillUnmount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
	}

	render() {
		let {  cardNumber } = this.state;
		return (
			<div className="mainBox"> 
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
		            </div>
		            <div>
		              <span>实名认证</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
		        <div className="boxContent">
					<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
						<div style={{fontSize: "13px", color: "#5b6370"}}>请通过绑定银行卡完成实名认证</div>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							持卡人
						</span>
						<span
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right'
						}}>
						{this.props.location.state.name}
						</span>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							卡号
						</span>
						<input autocomplete="off"
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right'
						}}
						value={cardNumber}
						onChange={this.changeCardNumber}
						placeholder="请输入卡号"
						/>
					</div>
					{
						cardNumber != "" ?
						<div style={{
							display: "-webkit-flex",
							marginTop: 15,
							height: 40,
							backgroundColor: "#fa063a",
							WebkitJustifyContent: "center",
							WebkitAlignItems: "center",
							borderRadius: 30,
							marginLeft: 13,
							marginRight: 13,
							marginBottom: 15
						}}
						key={0}
						onClick={this.goCertification}
						>
							<div style={{color: "#fff", fontSize: 15}}>下一步</div>
						</div> :
						<div style={{
							display: "-webkit-flex",
							marginTop: 15,
							height: 40,
							backgroundColor: "#afb0b2",
							WebkitJustifyContent: "center",
							WebkitAlignItems: "center",
							borderRadius: 30,
							marginLeft: 13,
							marginRight: 13,
							marginBottom: 15
						}}
						key={0}
						>
							<div style={{color: "#fff", fontSize: 15}}>下一步</div>
						</div>
					}
					<div className='addCard-tipBox'>
              <p>温馨提示 :</p>
              <p>如果您的银行卡是由交通银行、浦发银行、平安银行或邮储银行发行的。您需要先通过电脑访问银联官网开通该卡的银联在线支付，网址：https://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay。开通成功后，再通过APP绑定该类银行卡即可。为此造成的不便，敬请谅解。</p>
            </div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state,ownProps) {
  return {
    smrzCardNumber: state.smrzCardNumber
  }
}

export default connect(mapStateToProps)(CertificationCardAgain);


// WEBPACK FOOTER //
// ./src/components/recommend/CertificationCardAgain.js